import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import SignIn from '../../../components/sign-in/sign-in'
import ErrorPopup from '../../../components/error-popup/error-popup'

export class SignInPage extends Component {
  render() {
    const {t, errorMessage} = this.props

    return (
      <div>
        <ErrorPopup error={t(errorMessage)} extraClasses="xs-text-center" />
        <SignIn {...this.props} />
      </div>
    )
  }
}

SignInPage.propTypes = {
  errorMessage: PropTypes.string,
  t: PropTypes.func,
}

SignInPage.defaultProps = {
  errorMessage: null,
  t: PropTypes.func,
}

const mapStateToProps = (state) => ({
  ...state.app,
  ...state.auth,
  facebookError: state.facebook.signInError,
  googleError: state.google.signInError,
  twitterError: state.twitter.signInError,
  signInError: state.session.signInError,
  missingFields: state.session.missingFields,
  clientId: state.session.client_id,
  provider: state.session.provider,
  providerSecret: state.session.providerSecret,
  providerToken: state.session.providerToken,
})

const mapDispatchToProps = dispatch => ({
  handleAction: (type, payload) => dispatch({ type, payload }),
})

export default connect(mapStateToProps, mapDispatchToProps)(
  translate()(SignInPage),
)



// WEBPACK FOOTER //
// ./src/containers/pages/sign-in-page/sign-in-page.js